export const VERCEL_HEADER_KEY = 'x-api-origin-backend';
export const VERCEL_HEADER_VALUE =
  '_vercel_aeebed57-43ef-45fd-9a3f-456a57aec170';
